(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGallery(root) {
    (root || document).querySelectorAll('[data-mt-gallery]').forEach(function (g) {
      if (g.dataset.ready) return;
      g.dataset.ready = '1';
      var main = g.querySelectorAll('[data-mt-slide]');
      var thumbs = g.querySelectorAll('[data-mt-thumb]');
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          main.forEach(function (m, j) { m.classList.toggle('is-active', i === j); });
          thumbs.forEach(function (x, j) { x.classList.toggle('is-active', i === j); });
        });
      });
    });
  }

  function initQty(root) {
    (root || document).querySelectorAll('[data-mt-qty]').forEach(function (q) {
      if (q.dataset.ready) return;
      q.dataset.ready = '1';
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v += b.dataset.step === 'up' ? 1 : -1;
          input.value = Math.max(1, v);
        });
      });
    });
  }

  // Delegado en document: también funciona en formularios que aparecen después (ej. sugerencia dentro del carrito).
  function initAddToCart() {
    if (window.__mtAddReady) return;
    window.__mtAddReady = true;
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form.matches || !form.matches('form[data-mt-add]')) return;
      (function () {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || !window.fetch) return;
        ev.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
        var fd = new FormData(form);
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
        fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { window.location.href = window.routes.cart_url; return; }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
      })();
    });
  }

  // Precio de oferta: al pasar la fecha de término vuelve al precio normal sin recargar.
  function initPriceEnd(root) {
    var els = (root || document).querySelectorAll('[data-mt-price-end]');
    if (!els.length) return;
    function check() {
      els.forEach(function (el) {
        if (Date.parse(el.dataset.mtPriceEnd) > Date.now()) return;
        el.querySelectorAll('.mt-pdp__price-offer').forEach(function (o) { o.hidden = true; });
        el.querySelectorAll('.mt-pdp__price-base').forEach(function (b) { b.hidden = false; });
      });
    }
    check(); setInterval(check, 30000);
  }

  // Botón fijo en celular: aparece cuando el botón principal de compra sale de la pantalla hacia arriba.
  function initSticky(root) {
    (root || document).querySelectorAll('[data-mt-sticky]').forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var form = bar.parentElement.querySelector('form[data-mt-add]');
      var btn = bar.querySelector('[data-mt-sticky-buy]');
      if (!form || !btn || !('IntersectionObserver' in window)) return;
      btn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type="submit"]').click();
      });
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        btn.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('mt-sticky-on', on);
      }).observe(form);
    });
  }

  // Selector de pack: al elegir una opción, fija la cantidad del formulario de compra de la misma sección.
  function initPacks(root) {
    (root || document).querySelectorAll('[data-mt-packs]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var section = box.closest('.mt-pdp__info') || document;
      box.addEventListener('change', function (e) {
        if (!e.target.matches('input[type="radio"]')) return;
        var qty = section.querySelector('form[data-mt-add] input[name="quantity"]');
        if (qty) qty.value = e.target.value;
        var sum = box.querySelector('[data-mt-pack-sum]');
        if (sum && e.target.dataset.sum) sum.textContent = e.target.dataset.sum;
        updatePrepay(section, +e.target.value);
      });
    });
  }

  // Botón "pagar ahora": link directo al pago con la cantidad elegida; desde el mínimo de frascos agrega el código de descuento.
  function updatePrepay(scope, qty) {
    var box = scope.querySelector('[data-mt-prepay]');
    if (!box) return;
    var d = box.dataset, pack = qty >= (+d.min || 2);
    box.querySelector('a').href = '/cart/' + d.variant + ':' + qty + (pack && d.code ? '?discount=' + encodeURIComponent(d.code) : '');
    box.querySelector('[data-mt-prepay-sub]').textContent = pack ? d.notePack : d.note;
  }

  function initPrepay(root) {
    (root || document).querySelectorAll('[data-mt-prepay]').forEach(function (box) {
      var scope = box.closest('.mt-pdp__info') || document;
      var picked = scope.querySelector('[data-mt-packs] input:checked');
      updatePrepay(scope, picked ? +picked.value : 1);
    });
  }

  // "¿Cuándo te llega?": fechas estimadas sumando días hábiles (sin fines de semana ni feriados) desde hoy.
  function initEta(root) {
    var days = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    var months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
    function fmt(d) { return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()]; }
    function range(a, b) {
      if (iso(a) === iso(b)) return fmt(a);
      if (a.getMonth() === b.getMonth()) return days[a.getDay()] + ' ' + a.getDate() + ' – ' + fmt(b);
      return fmt(a) + ' – ' + fmt(b);
    }
    (root || document).querySelectorAll('[data-mt-eta]').forEach(function (box) {
      var holidays = (box.dataset.holidays || '').split(',').map(function (s) { return s.trim(); });
      function isWork(d) { return d.getDay() !== 0 && d.getDay() !== 6 && holidays.indexOf(iso(d)) === -1; }
      function addWork(n) {
        var d = new Date(); d.setHours(12, 0, 0, 0);
        while (n > 0) { d.setDate(d.getDate() + 1); if (isWork(d)) n--; }
        return d;
      }
      function span(attr) { var p = (attr || '').split('-'); return range(addWork(+p[0] || 0), addWork(+p[1] || 0)); }
      var out = function (k) { return box.querySelector('[data-eta="' + k + '"]'); };
      out('today').textContent = fmt(new Date());
      out('ship').textContent = span(box.dataset.ship);
      out('arrive').textContent = span(box.dataset.arrive);
    });
  }

  // Carrito: si el botón de pagar trae código de pago con tarjeta, va al pago con el descuento ya aplicado.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="checkout"][data-mt-pp-code]');
    if (!btn) return;
    e.preventDefault();
    window.location.href = '/checkout?discount=' + encodeURIComponent(btn.dataset.mtPpCode);
  }, true);

  // El código de pago con tarjeta queda guardado en el carrito tras usar el botón "pagar ahora";
  // se quita al volver a la tienda para que no aparezca en el pago contra entrega (se vuelve a aplicar solo al pagar con tarjeta).
  (function clearPrepayCode() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var has = (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === 'PAGOAHORA'; });
      if (!has) return;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) })
        .then(function () { if (document.querySelector('cart-drawer, #main-cart-items')) window.location.reload(); });
    }).catch(function () {});
  })();

  function initAll(root) { initReveal(root); initGallery(root); initQty(root); initAddToCart(root); initPriceEnd(root); initSticky(root); initPacks(root); initEta(root); initPrepay(root); }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
